var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"me"},[_c('van-contact-card',{attrs:{"type":"edit","name":_vm.userinfo.nickName,"tel":_vm.userinfo.account,"editable":false}}),_c('div',{staticClass:"logout"},[_c('el-button',{staticClass:"logout_btn",attrs:{"type":"primary"},on:{"click":_vm.handleLogoutBtnClick}},[_vm._v("退出登录")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }